import ons from "onsenui";
import React from "react";

interface GoogleDocsViewerProps {
  documentUrl: string;
  onLoad?: () => void;
  onError?: () => void;
}

export class GoogleDocsViewer extends React.PureComponent<GoogleDocsViewerProps> {
  static readonly MAX_LOAD_TIMEOUT = 10000;

  constructor(props: GoogleDocsViewerProps) {
    super(props);

    this.state = {};

    if (!ons.platform.isIOS()) {
      this.timeout = setTimeout(this.timeoutFired, this.prevTimeoutValue);
    }
  }

  timeoutFired = (): void => {
    if (this.iframeRef !== null) {
      // Reload iframe:
      this.iframeRef.src = this.iframeRef.src; // eslint-disable-line no-self-assign

      this.prevTimeoutValue = this.prevTimeoutValue * 2;
      if (this.prevTimeoutValue > GoogleDocsViewer.MAX_LOAD_TIMEOUT) {
        this.prevTimeoutValue = GoogleDocsViewer.MAX_LOAD_TIMEOUT;
      }
      this.timeout = setTimeout(this.timeoutFired, this.prevTimeoutValue);
    }
  };

  private timeout: any | null = null;
  private iframeRef: HTMLIFrameElement | null = null;

  private prevTimeoutValue: number = 1000;

  componentWillUnmount() {
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }
  }

  handleIframeLoad = (): void => {
    if (this.iframeRef !== null) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      if (this.props.onLoad !== undefined) {
        this.props.onLoad();
      }
    }
  };

  render() {
    return (
      <iframe
        ref={(e) => (this.iframeRef = e)}
        onLoad={this.handleIframeLoad}
        onError={this.props.onError}
        style={{ flexGrow: 1 }}
        src={
          "https://docs.google.com/gview?embedded=true&url=" +
          encodeURIComponent(this.props.documentUrl)
        }
      />
    );
  }
}
